"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const one_1 = require("remax/one");
const cascade_1 = __importDefault(require("../cascade"));
const loading_1 = __importDefault(require("../loading"));
const popup_1 = __importDefault(require("../popup"));
const icon_1 = __importDefault(require("../icon"));
const form_value_1 = __importDefault(require("../form-value"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('cascade-popup');
const CascadePopup = (props) => {
    const { value, text, disabled, placeholder, options, onComplete } = props;
    const [show, setShow] = react_1.useState(false);
    const handleComplete = (value, values) => {
        onComplete === null || onComplete === void 0 ? void 0 : onComplete(value, values);
        setShow(false);
    };
    const handleTap = () => {
        if (disabled) {
            return;
        }
        setShow(true);
    };
    const handleClose = () => {
        setShow(false);
    };
    if (!options || options.length === 0) {
        return (React.createElement(one_1.View, { className: prefixCls },
            React.createElement(one_1.View, { className: `${prefixCls}-loading` },
                React.createElement(loading_1.default, null))));
    }
    return (React.createElement(one_1.View, { className: prefixCls },
        React.createElement(one_1.View, { className: `${prefixCls}-formitem`, onTap: handleTap },
            React.createElement(form_value_1.default, { placeholder: placeholder }, text || (value === null || value === void 0 ? void 0 : value.map(i => i.name).join(' ')))),
        React.createElement(popup_1.default, { position: "bottom", open: show },
            React.createElement(one_1.View, { className: `${prefixCls}-container` },
                React.createElement(one_1.View, { className: `${prefixCls}-container-header` },
                    React.createElement(one_1.View, null, "\u8BF7\u9009\u62E9"),
                    React.createElement(one_1.View, { className: `${prefixCls}-container-header-close`, onTap: handleClose },
                        React.createElement(icon_1.default, { type: "close", color: "#999" }))),
                React.createElement(cascade_1.default, Object.assign({}, props, { onComplete: handleComplete }))))));
};
exports.default = CascadePopup;
